export default {"id":"34a8ec97","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}